export const colors = {
  brandPrimaryDefault: "#ef6000",
  brandPrimaryTint: "#FFE5D1",
  brandPrimaryShade: "#8E4918",
  brandSecondaryDefault: "#054A71",
  brandSecondaryTint: "#B3D4DF",
  brandSecondaryShade: "#051725",
  brandGradientDefault: "linear-gradient(125deg, #052855 0%, #052855 100%)",
  brandGradientColorStopsStart: "#052855",
  brandGradientColorStopsEnd: "#052855",
  productColorsPrimaryL5: "#FFF2E8",
  productColorsPrimaryL4: "#FFE5D1",
  productColorsPrimaryL3: "#FFCBA5",
  productColorsPrimaryL2: "#FFB07A",
  productColorsPrimaryL1: "#FF954E",
  productColorsPrimary: "#ef6000",
  productColorsPrimaryD1: "#C94e08",
  productColorsPrimaryD2: "#8E4918",
  productColorsPrimaryD3: "#5E3214",
  productColorsPrimaryD4: "#311D0E",
  productColorsSecondaryL5: "#e6f1f4",
  productColorsSecondaryL4: "#B3D4DF",
  productColorsSecondaryL3: "#80B7CA",
  productColorsSecondaryL2: "#4D9AB5",
  productColorsSecondaryL1: "#006E95",
  productColorsSecondary: "#054A71",
  productColorsSecondaryD1: "#04315D",
  productColorsSecondaryD2: "#162740",
  productColorsSecondaryD3: "#081F30",
  productColorsSecondaryD4: "#051725",
  contentBrandPrimary: "#ef6000",
  contentBrandSecondary: "#B3D4DF",
  backgroundBrand: "#ef6000",
  borderBrand: "#ef6000",
  componentButtonPrimaryContentBase: "#0a0a0a",
  componentButtonPrimaryContentHover: "#0a0a0a",
  componentButtonPrimaryContentActive: "#0a0a0a",
  componentButtonPrimaryBackgroundBase: "#ef6000",
  componentButtonPrimaryBackgroundHover: "#C94e08",
  componentButtonPrimaryBackgroundActive: "#8E4918",
  componentButtonPrimaryBorderBase: "#ef6000",
  componentButtonPrimaryBorderHover: "#C94e08",
  componentButtonPrimaryBorderActive: "#8E4918",
};

export const text = {
  themeName: "Mohegan Sun",
};